import React from "react"
import PropTypes from "prop-types"
import { makeStyles, useTheme } from "@material-ui/core/styles"

import AppBar from "@material-ui/core/AppBar"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import Overview from "./Overview/overview"
import ChromeReaderModeOutlinedIcon from "@mui/icons-material/ChromeReaderModeOutlined"
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined"
import CourseDetailsVideo from "./CourseModules"
import Notes from "./Notes"
import SwipeableViews from "react-swipeable-views"
import Announcements from "./Announcements"

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}))

export default function ScrollableTabsButtonAuto(props) {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)
  const theme = useTheme()

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const handleChangeIndex = (index) => {
    setValue(index)
  }
  return (
    <Wrapper>
      <div className={classes.root}>
        <div className="course_details_desktop_version">
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab
                label={<h2 className="tab_h2">overview</h2>}
                {...a11yProps(0)}
              />
              <Tab
                label={<h2 className="tab_h2">announcements</h2>}
                {...a11yProps(1)}
              />
              <Tab
                label={<h2 className="tab_h2">notes</h2>}
                {...a11yProps(2)}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <Overview
              overview={props.data.overview}
              ReadMoreProps={props.ReadMoreProps}
              shortDesc={
                props.data.short_descrption || props.data.short_description
              }
            />
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Announcements data={props.data} />
          </TabPanel>

          <TabPanel value={value} index={2}>
            <Notes
              onPlayPause={props.OnPlayPause}
              showNotes={props.showNotes}
              handleCancel={props.handleCancel}
              data={props.data}
              player={props.player}
              curriculumIndex={props.curriculumIndex}
              subtopicIndex={props.subtopicIndex}
              elapsedTime={props.elapsedTime}
              progress={props.progress}
              keyId={props.keyId}
            />
          </TabPanel>
        </div>

        {/* tablet version tab */}
        <div className="course_details_tablet_version">
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab
                icon={<ChromeReaderModeOutlinedIcon />}
                label={<h2 className="tab_h2">contents</h2>}
                {...a11yProps(0)}
              />
              <Tab
                icon={<ChromeReaderModeOutlinedIcon />}
                label={<h2 className="tab_h2">overview</h2>}
                {...a11yProps(1)}
              />

              <Tab
                icon={<CampaignOutlinedIcon />}
                label={<h2 className="tab_h2">announcements</h2>}
                {...a11yProps(2)}
              />
              <Tab
                icon={<CampaignOutlinedIcon />}
                label={<h2 className="tab_h2">notes</h2>}
                {...a11yProps(2)}
              />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0}>
              <CourseDetailsVideo
                data={props.data}
                handleSubmit={props.handleSubmit}
                keyId={props.keyId}
                uri={props.uri}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Overview
                overview={props.data.overview}
                ReadMoreProps={props.ReadMoreProps}
                shortDesc={
                  props.data.short_descrption || props.data.short_description
                }
              />
            </TabPanel>

            <TabPanel value={value} index={2}>
              <Announcements data={props.data} />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <Notes
                onPlayPause={props.OnPlayPause}
                showNotes={props.showNotes}
                handleCancel={props.handleCancel}
                data={props.data}
                player={props.player}
                curriculumIndex={props.curriculumIndex}
                subtopicIndex={props.subtopicIndex}
                elapsedTime={props.elapsedTime}
                progress={props.progress}
                keyId={props.keyId}
              />
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  /*        
        .MuiTab-wrapper{
            color:white;
        }
         */
  width: 80%;
  height: auto;
  margin-top: 10px;
  @media (max-width: 767px) {
    width: 100%;
  }
  .course_details_tablet_version {
    display: none;
  }
  .MuiTab-labelIcon {
    min-height: 0;
  }
  .MuiTabs-scroller {
    position: absolute;

    z-index: 2;
    @media (max-width: 991px) {
      width: 100%;
    }
  }
  .MuiPaper-elevation4 {
    box-shadow: none !important;
  }
  .tab_h2 {
    font-weight: 600;
    font-size: 18px;
    color: #000 !important;
    margin: 0;
    @media (max-width: 767px) {
      font-size: 16px;
    }
  }
  .MuiPaper-root {
    @media (max-width: 767px) {
      margin-top: 0px;
    }
  }
  .MuiTab-textColorPrimary.Mui-selected {
    color: var(--purpleColor);
    .tab_h2 {
      text-decoration-color: var(--purpleColor);
      color: #9300e4 !important;
    }
  }
  .PrivateTabIndicator-colorPrimary-33 {
    background-color: #fff;
  }
  .MuiTab-root {
    font-weight: 500;
  }
  .MuiTab-textColorPrimary {
    color: #fff;
  }
  .MuiTabs-indicator {
    display: none;
  }
  .MuiTabs-root {
    background: #fff;
    align-items: center;
    border-bottom: 1.5px solid #1515154f;
    padding-bottom: 20px;
    padding-top: 20px;
  }
  .MuiBox-root {
    padding: 30px 0px !important;
  }
  .MuiTab-wrapper {
    flex-direction: row;
    align-items: center;
  }
  .MuiSvgIcon-root {
    margin-bottom: 0px !important;
    margin-right: 5px;
    color: var(--purpleColor);
  }
  .PrivateTabIndicator-root-10 {
    background-color: transparent;
  }
  @media (max-width: 767px) {
    .course_details_desktop_version {
      display: none;
    }
    .course_details_tablet_version {
      display: block;
    }
  }
`
